/* eslint-disable*/
import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AiFillPrinter } from "react-icons/ai";
import { IoMailOutline } from "react-icons/io5";
import { IoMdArrowBack } from "react-icons/io";
import BookingModal from "./BookingModal";
import BookingEditModal from "./BookingEditModal";
import BtnModalExpenses from "./Booking/BtnModalExpenses";
import BtnModalDiscount from "./Booking/BtnModalDiscount";
import BtnModalPost from "./Booking/BtnModalPost";
import moment from "moment";
import { axiosInstanceWithToken } from "../helpers/axios";
import BookingDetailsTabs from "./Details/BookingDetailsTabs";
import Swal from "sweetalert2";
import { chatServerInstanceWithToken } from "@/helpers/chat_server_instance";
import { fDateMoment } from "@/utils/formatDate";

const BookingViewR = () => {
  const [openPost, setOPenPost] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { row, isHost = false } = location.state;

  const [booking, setBooking] = useState();
  const [loading, setLoading] = useState(true);
  const [expenseList, setExpenseList] = useState([
    {
      expense_name: "",
      expense_value: "",
      status: "pending",
      booking_id: row?.id,
      expense_qty: "",
      expense_type: "",
    },
  ]);

  const [discountList, setDiscountList] = useState([{ name: "", value: "" }]);

  useEffect(() => {
    axiosInstanceWithToken.get(`/booking/${row.id}`).then(({ data }) => {
      setBooking({
        ...data?.data,
        meta_data:
          typeof data?.data?.meta_data === "string"
            ? JSON.parse(data?.data?.meta_data)
            : data?.data?.meta_data,
      });
      setLoading(false);
    });
  }, [row]);

  const isConfirm = booking?.status === "CONFIRMED";
  const isDeclined = booking?.status === "DECLINED";

  const arriveDate = moment(booking?.arrival_date); // Ensure this is a Moment object
  const departDate = moment(booking?.departure_date); // Ensure this is a Moment object

  const arrival = fDateMoment(booking?.arrival_date); // "Apr 08 2025"
  const departure = fDateMoment(booking?.departure_date); // Formatted output

  // Now you can safely clone and use diff
  const diffDays = departDate.diff(arriveDate, "days"); // Calculate difference in days
  let hasWeekend = false;
  // Check if any date in the range is a weekend (Saturday or Sunday)
  const weekendDays = []; // To store weekend dates if needed

  let currentDate = moment(booking?.arrival_date).clone(); // Clone the Moment.js object

  while (currentDate.isSameOrBefore(departDate)) {
    const dayOfWeek = currentDate.day(); // 0 = Sunday, 6 = Saturday
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      hasWeekend = true;
      weekendDays.push(currentDate.clone().format("MMM DD YYYY")); // Store formatted date
    }
    currentDate.add(1, "days"); // Move to the next day
  }

  const handleConfirmBooking = useCallback(
    (status, rejectionReason = "", meta_data = null) => {
      let data = new FormData();
      data.append("_method", "PATCH");
      if (status === "COMPLETED") {
        data.append("status", status);
      } else data.append("is_approved", status);

      let updatedMetaData = {
        ...meta_data,
      };

      if (status === 0) {
        // Ensure a rejection reason is provided
        if (!rejectionReason.trim()) {
          Swal.fire("Please provide a rejection reason", "", "error");
          return;
        }

        // Update meta_data if rejected
        updatedMetaData = {
          ...updatedMetaData,
          rejection_reason: rejectionReason,
          rejected_at: new Date().toISOString(),
        };
      }

      data.append("meta_data", JSON.stringify(updatedMetaData));
      // update meta_data if rejected
      axiosInstanceWithToken
        .post(`/booking/${row?.id}`, data)
        .then((response) => {
          if (+status === 1) {
            const chatData = {
              participant_1: row?.guest?.id,
              participant_2: row?.listing?.host_id,
              admin_id: null,
              booking_id: row?.id,
            };

            // Make an API call to create the chat between the participants (and admin if needed)
            chatServerInstanceWithToken
              .post("/createChat", chatData)
              .then((chatResponse) => {
                if (chatResponse.status === 201) {
                  Swal.fire(
                    "Booking confirmed, and chat created!",
                    "",
                    "success"
                  );
                  navigate("/booking", { replace: true });
                }
              })
              .catch((chatError) => {
                console.error("Error creating chat:", chatError);
                Swal.fire("Error creating chat, please try again", "", "error");
              });
          } else {
            navigate("/booking", { replace: true });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    []
  );

  function PrintElem() {
    var elemContent = document.getElementById("elem").innerHTML;
    var mywindow = window.open("", "PRINT", "height=400,width=600");

    mywindow.document.write("<html><head>");
    mywindow.document.write("</head><body>");
    mywindow.document.write(elemContent);
    mywindow.document.write("</body></html>");

    mywindow.document.close();

    // Wait for the content to load
    mywindow.onload = function () {
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    };

    return true;
  }
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [expenses, setExpenses] = useState(false);
  const [openDiscount, setOpenDiscount] = useState(false);
  const [images, setImages] = useState(false);
  const [postValueInput, setPostValueInput] = useState({
    situation_description: "",
    reason: "",
    amount: 0,
    status: "pending",
  });

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-5">
        <img
          className="h-auto w-36 md:w-44" // Responsive sizes
          src="/image/fly-inn-logo.svg"
          alt="Fly Inn Logo"
        />
        <div className="text-2xl text-bold">
          {" "}
          Please Wait while we load your data!
        </div>
      </div>
    );
  }

  return (
    <>
      {expenses && (
        <BtnModalExpenses
          expenseList={expenseList}
          setExpenseList={setExpenseList}
          expenses={expenses}
          setExpenses={setExpenses}
        />
      )}
      {openDiscount && (
        <BtnModalDiscount
          discountList={discountList}
          setDiscountList={setDiscountList}
          openDiscount={openDiscount}
          setOpenDiscount={setOpenDiscount}
        />
      )}
      {openPost && (
        <BtnModalPost
          postValueInput={postValueInput}
          setPostValueInput={setPostValueInput}
          openPost={openPost}
          setOPenPost={setOPenPost}
          images={images}
          setImages={setImages}
        />
      )}

      <main className="col-md-12" style={{ marginTop: "30px" }}>
        <div className="flex col-md-12">
          <div
            className="col-md-12"
            style={{ paddingBottom: "20px" }}
            id="elem"
          >
            <div style={{ padding: "16px" }}>
              <h1> Booking Details</h1>
              <div className="container flex justify-end gap-2 w-full p-6 bg-white !rounded-none">
                <div className="p-2 text-white bg-gray-400 rounded-md shadow-md icon_button_booking">
                  <AiFillPrinter
                    style={{ cursor: "pointer" }}
                    onClick={PrintElem}
                    size={20}
                  />
                </div>
                <Link
                  to={"/air_mail"}
                  className="p-2 text-white bg-gray-400 rounded-md shadow-md icon_button_booking"
                >
                  <IoMailOutline style={{ cursor: "pointer" }} size={20} />
                </Link>
                <div className="p-2 text-white bg-gray-400 rounded-md shadow-md icon_button_booking">
                  <IoMdArrowBack
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(-1)}
                    size={20}
                  />
                </div>
              </div>

              <BookingDetailsTabs
                booking={booking}
                arrival={arrival}
                departure={departure}
                diffDays={diffDays}
                isConfirm={isConfirm}
                isDeclined={isDeclined}
                isHost={isHost}
                handleConfirmBooking={handleConfirmBooking}
                expenses={expenses}
                setExpenses={setExpenses}
                openDiscount={openDiscount}
                setOpenDiscount={setOpenDiscount}
                openPost={openPost}
                setOPenPost={setOPenPost}
              />
            </div>
          </div>
        </div>
      </main>
      {isOpen && <BookingModal isOpen={isOpen} setIsOpen={setIsOpen} />}
      {isOpen2 && (
        <BookingEditModal isOpen2={isOpen2} setIsOpen2={setIsOpen2} />
      )}
    </>
  );
};

export default BookingViewR;
